import { HttpClient } from '@angular/common/http';
import { ElementRef } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';


export class EmailVerificationImplementation {

    static singleInstance: EmailVerificationImplementation;
    http: HttpClient;
    loginImpl;
    showVerificationBanner:Boolean = false;
    localStorageSvc: LocalStorageSvc;
    userData:any;
    emailId:string;
    mobileNo:number;
    showOtpError: boolean;
    showOtpErrorMsg:string;
    universalService
    showInputOtpScreen: boolean;
    showValidateEmailScreen: boolean =true;
    showsuccessullyValidatedScreen: boolean;
    isMandatoryEmailActive: any = false;
    isShowEmailVerifyModal:boolean =false;
    userIdentification: any;
    isResendEmailOtp: boolean = false;
    cleverTapEventsService: any;
    enableButton:boolean = false;
    userProfileDetails: any = [];
    containerHeightCalc: any;
    recalculateHeightService: any;
    router: any;

    private constructor(globalService){
       this.http = globalService.getHttpClientRef();
       this.localStorageSvc = globalService.getLocalStorageSvcRef();
       this.universalService = globalService.getUniversalServiceRef();
       this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
       this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
       this.recalculateHeightService = this.containerHeightCalc;
       this.router = globalService.getRouterRef();
    }


    public static getInstance(globalService):EmailVerificationImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new EmailVerificationImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
    }

    checkEmailVerificationBannerStatus(userdata){
      let isMandatoryEmailActive = localStorage.getItem('isMandatoryEmailActive' + userdata.userId);
      this.isMandatoryEmailActive = isMandatoryEmailActive ? JSON.parse(isMandatoryEmailActive) : isMandatoryEmailActive;
  
      if (userdata.isEmailIdVerified == false && !this.isMandatoryEmailActive) { // this.isMandatoryEmailActive false, 
         
        const emailExpiryProp: string = 'expiryForEmailVerification' + userdata.userId;
        const emailVerificationStartProp: string = 'emailVerificationStartDate' + userdata.userId
        const expiryForEmailVerification = localStorage.getItem(emailExpiryProp);
        const emailVerificationStartDate = localStorage.getItem(emailVerificationStartProp);
  
        if (!expiryForEmailVerification && !emailVerificationStartDate) {  // checkIsMandatoryEmailActive false & no start and end date in localStorage
          
          var date1 = new Date(); //start date
          var date2 = new Date(); // after 23 days date
          date2.setDate(date1.getDate() + 10)
          localStorage.setItem(emailExpiryProp, date2.toString());
          localStorage.setItem(emailVerificationStartProp, date1.toString());
          this.showEmailVerificationBanner();
          this.showEmailVerifyModal();
        } else {                                                // checkIsMandatoryEmailActive false & start and end date in localStorage
          var firstDate = new Date();
          var secondDate = new Date(expiryForEmailVerification);
          firstDate.setHours(0, 0, 0, 0);
          secondDate.setHours(0, 0, 0, 0);
          if (firstDate.getTime() >= secondDate.getTime()) {   // 23rd day showing EmailVerifyModal
            userdata.emailDateExpiry = true;
            this.hideEmailVerificationBanner();
            this.showEmailVerifyModal();
          } else {                                             // Not 23 days yet, showing EmailVerifficationBanner
            this.showEmailVerificationBanner();
          }
        }
      } else if (userdata.isEmailIdVerified == false && this.isMandatoryEmailActive) {
  
        this.hideEmailVerificationBanner();  // checkIsMandatoryEmailActive true, hiding banner showing verify modal
        this.showEmailVerifyModal();
    
      } else if (userdata.isEmailIdVerified == true) {
           this.hideEmailVerificationBanner();  // email  already verified, hiding banner
      } else {
        this.hideEmailVerificationBanner();   // email  already verified, hiding banner
      }
  
    }

    showEmailVerifyModal(){
      setTimeout(()=>{
        let userData = this.localStorageSvc.getUserData(true);
        this.emailId = userData.emailId ? userData.emailId : '';
        let el = document.getElementById('email-txtbx')as any;
        el.value = this.emailId;
        this.universalService.isShowEmailVerifyModal  = true;
        this.universalService.popUpToBeOpened = "dummy";
        this.cleverTapEventsService.mandatoryEmailModalViewed();
      }, 500)
     
    }

    showEmailVerificationBanner(){
      const isReferralPopupShown = localStorage.getItem('isReferralPopupShown_' + this.userData.userId);
      if(isReferralPopupShown == "true"){
        this.showVerificationBanner = true;
        this.recalculateHeightService.sendRecalculateEventToComponents(true);
      } else {
        setTimeout(()=>{
          this.showVerificationBanner = true;
          this.recalculateHeightService.sendRecalculateEventToComponents(true);
        },11000)
      }
    }
  
    hideEmailVerificationBanner(){
     this.showVerificationBanner = false;
    }
    hideEmailVerifyModal(){
      this.universalService.popUpToBeOpened = "";
      this.universalService.isShowEmailVerifyModal =false;
      this.universalService.disableModalBackdrop();
    }
  
    
    sendEmailVerificationOtp(value:ElementRef,type){
      this.showOtpErrorMsg = ""
      this.showOtpError = false;
      let params;
      const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls.sendEmailVerficationOtp;
      //console.log("Ajay  this.universalService.mobileNoVerification::", this.universalService.mobileNoVerification,":: this.universalService.backupNoVerification::", this.universalService.backupNoVerification) 
      if(type == 'email'){
        params = { "emailId":value }
      }else if(type == 'phone'){
        let userData = this.localStorageSvc.getUserData(true);
        if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 ){
          params = { "mobileNumber":value }
        }else if(userData.authProviderId == 4 || userData.authProviderId == 25 || userData.authProviderId == 26 || userData.authProviderId == 27){
          params = { "backupMobileNumber":value }
        }
      }
      

      this.http.post(url, params).subscribe(suc=>{
          this.showValidateEmailScreen = false;
          this.showInputOtpScreen = true;
          this.showOtpErrorMsg = ""
          this.showOtpError = false;
          if(this.isResendEmailOtp){
            if(type == 'email'){
              this.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY"], "success");
            }else{
              this.universalService.showToast(TOAST["OTP_SENT_SUCCESSFULLY_MOBILE"], "success");
            }
            this.isResendEmailOtp = false;
            this.clearLoginInput();
          }
          if(type == 'email'){
            this.cleverTapEventsService.emailVerifyOtpReq('Email');
          }else{
            this.cleverTapEventsService.emailVerifyOtpReq('Mobile');
          }
          
      }, error=> {
          this.showOtpError = true;
          this.isResendEmailOtp= false;
          let errrorObj = error.error;
          this.cleverTapEventsService.emailVerifyOtpError(errrorObj)
          if ( errrorObj.code === "SCLN0401") {
            this.showOtpErrorMsg = errrorObj.error;
            this.showOtpError = true;
          } else if(errrorObj.code === "TEJVF0002"){
            this.showOtpErrorMsg = HTML_ERRORS["INVALID_EMAIL"];
            this.showOtpError = true;
          } else if (errrorObj.code === "SCLN0309") {
            this.showOtpErrorMsg = HTML_ERRORS["EMAIL_VERIF_MAX_LIMIT"];
            this.showOtpError = true;
          }else if (errrorObj.code === "SCLN0108" || errrorObj.code === "SCLN0109" || errrorObj.code === "SCLN0107") {
						this.showOtpErrorMsg = TOAST["MAX_EMAIL_VERIF_LIMIT_REACHED"];
            this.showOtpError = true;
					} else if (errrorObj.code === "SCLN0182" || errrorObj.code === "SCLN0314" || errrorObj.code === "SCLN0111" || errrorObj.code === "SCLN0192" || errrorObj.code === "SCLN0193" || errrorObj.code === "SCLN0194"  || errrorObj.code === "SCLN0195" || errrorObj.code === "SCLN0196" || errrorObj.code === "SCLN0197" || errrorObj.code === "SCLN0198" || errrorObj.code === "SCLN0199" || errrorObj.code === "SCLN0200"|| errrorObj.code === "SCLN0201" || errrorObj.code === "SCLN0202") {
            this.showOtpErrorMsg = errrorObj.error;
            this.showOtpError = true;
          }else {
            this.showOtpError = false;
            //let notificationMessage = "Oops something went wrong."
            this.universalService.showToast(TOAST["GENERIC_ERROR"],"error")
          }
      })

    }

    clearLoginInput(){
      for (var i = 1; i < 7; i++) {
        if (<HTMLInputElement>document.getElementById("digit" + i) != null) {
          (<HTMLInputElement>document.getElementById("digit" + i)).value = "";
        }
      }
      this.enableButton = false;
      setTimeout(() => {
      (<HTMLInputElement>document.getElementById("digit1")).focus();
      }, 1000);
    }

    verifyEmailVerificationOTP(value:string, otp:string,type:string){

        this.showOtpErrorMsg = ""
        this.showOtpError = false;
        let params;
        const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls.verifyEmailVerficationOtp;
        if(type == 'email'){
          params = { 
            "emailId":value,
            "otp":otp
          }
        }else if(type == 'phone'){
          let userData = this.localStorageSvc.getUserData(true);
          if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 ){
            params = { 
              "mobileNumber":value,
              "otp":otp
            }
          }else if(userData.authProviderId == 4 || userData.authProviderId == 25 || userData.authProviderId == 26){
            params = { 
              "backupMobileNumber":value,
              "otp":otp
            }
          }
        }
        this.http.post(url, params).subscribe(
          suc=>{
            let userData = this.localStorageSvc.getUserData(true);
            let src = userData.isMandatoryEmail == true ? 'Mandatory' : 'Profile'
            
            this.showInputOtpScreen = false;
            this.showsuccessullyValidatedScreen= true;
            userData.isMandatoryEmail = false;
            
            if(type == 'email'){
              userData['isEmailIdVerified'] = true
              this.universalService.emailId = value;
              userData['emailId'] = value;
              this.cleverTapEventsService.emailVerifySuccess(src);
            }else if(type == 'phone'){
              if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 ){
                userData['mobileNumber'] = parseInt(value);
                userData['isMobileNumVerified'] = true;
                this.cleverTapEventsService.mobileVerifySuccess('Profile');
              }else if(userData.authProviderId == 4 || userData.authProviderId == 25 || userData.authProviderId == 26){
                userData['backupMobileNumber'] = parseInt(value);
                this.cleverTapEventsService.backupMobileVerifySuccess('Profile');
              }
            }
            AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
            AppEvents.updateProfileDetails.next({ updateProfileDetails: true });
            this.showVerificationBanner= false;
            localStorage.setItem('isMandatoryEmailActive' + userData.userId, 'false');
          },error=> {
              this.clearLoginInput();
              let userData = this.localStorageSvc.getUserData(true);
              let src = userData.isMandatoryEmail == true ? 'Mandatory' : 'Profile'
              let errrorObj = error.error;
              if(type == 'email'){
                this.cleverTapEventsService.emailVerifyError(errrorObj,src)
              }else if(type == 'phone'){
                if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 ){
                  this.cleverTapEventsService.mobileVerifyError(errrorObj,'Profile')
                }else if(userData.authProviderId == 4 || userData.authProviderId == 25 || userData.authProviderId == 26){
                  this.cleverTapEventsService.backupMobileVerifyError(errrorObj,'Profile')
                }
              }
              
              if (errrorObj.code === "TEJVF0002" || errrorObj.code === "SCLN0401") {
                this.showOtpErrorMsg = errrorObj.error;
                this.showOtpError = true;
              } else if (errrorObj.code === "SCLN0312" || errrorObj.code === "SCLN0313" || errrorObj.code === "SCLN0040" || errrorObj.code === "SCLN0322" || errrorObj.code === "SCLN0182") {
                this.showOtpErrorMsg = HTML_ERRORS["INVALID_OTP"];
                this.showOtpError = true;
              } else if (errrorObj.code === "SCLN0111") {
                this.showOtpErrorMsg = errrorObj.error
                this.showOtpError = true;
              } else if(errrorObj.code ==="SCLN0325"){
                this.showOtpErrorMsg = HTML_ERRORS["EMAIL_VERIF_MAX_LIMIT"];
                this.showOtpError = true;
              }else {
                this.showOtpError = true;
                //let notificationMessage = "Oops something went wrong."
                this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
              }
        })
  
    }
}
